const category = 'AppSpecificInterest';

const cards = [
    {
        name: "Fees",
        id: "fees",
        category: "AppSpecificFees",
        fields: [
            [
                {
                    type: "content",
                    content: `
                        <p class="subtitle-2">Rebill fees if a dispute or claim is denied</p>
                        <p>If you choose to rebill fees, here's how it works:</p>
                        <ul>
                            <li>Any fees associated with a disputed transaction are reassessed if they were refunded during provisional credit and the dispute is later denied</li>
                            <li>Any fees not associated to a disputed transaction are reassessed if they were refunded during provisional credit and the claim is later denied (all disputes are denied)</li>
                        </ul>
                    `,
                    configNoMargin: true,
                },
            ],
            [
                {
                    type: "content",
                    content: `

                    `,
                    configNoMargin: true,
                },
            ],
            [
                {
                    id: "FeeProcessingRebill",
                    configHideLabel: true,
                },
            ],
            [
                {
                    type: "content",
                    content: `
                        <p class="subtitle-2">Configure additional fees</p>
                        <p>QFD will refund any fees associated with a disputed transaction by your system of record and configured within QFD's connection. This refund occurs when any provisional credit or final credit is issued, whichever comes first.</p>
                        <br />
                        <p>You can configure any additional fees below and automatically refund or review them if they occur within a period of time surrounding a disputed transaction.  We highly recommend never reviewing fees.  In almost all cases, it is less expensive to automatically refund them if they could be related to a disputed transaction.</p>                        
                        `,
                    configNoMargin: true,
                },
            ],
            [
                {
                    id: "FeeReviewList",
                    configHideLabel: true,
                    listItems: ["FeeDescription", "DaysBefore", "DaysAfter", "FeeAction", "UseContainsMatching"],
                },
            ],
            [
                {
                    id: "BOEnableManualOverdraftFeeReview",
                },
            ]
        ],
    },
    {
        name: "Interest",
        id: "interest",
        category: "AppSpecificInterest",
        fields: [
            [
                {
                    id: "InterestCalculationMethod",
                },
                {
                    id: "InterestDayCountConvention",
                },
                {
                    id: "CheckInterestMaintenanceImmediately",
                },
                {
                    id: "ExecuteRefundInterestAccountingImmediately",
                },
                {
                    id: "IsDisputeStatusMaintenanceEnabled",
                },
                {
                    id: "RemoveAmountInDiputeAtCustomerFinalProcessing",
                },
            ],
        ],
    }
];

export { cards, category };